import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'menu-editor',
    loadChildren: () => import('./pages/menu-editor/menu-editor.module').then(m => m.MenuEditorPageModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'history',
    loadChildren: () => import('./pages/order-history/order-history.module').then(m => m.OrderHistoryPageModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'batatas',
    loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminPageModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'register-business',
    loadChildren: () => import('./pages/register-restaurant/register-restaurant.module').then(m => m.RegisterRestaurantPageModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule),
    canActivateChild: [AuthGuard]
  },
  { path: 'edit-order',
    loadChildren: () => import('./pages/edit-order/edit-order.module').then(m => m.EditOrderPageModule),
    // loadChildren: './pages/edit-order/edit-order.module#EditOrderPageModule',
    canActivateChild: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
